import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Supabase 리프레시 토큰 만료 등 인증 관련 unhandled rejection을 조용히 처리
window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  if (reason && typeof reason === 'object') {
    const msg = reason.message || reason.error_description || '';
    if (
      msg.includes('Invalid Refresh Token') ||
      msg.includes('Refresh Token Not Found') ||
      msg.includes('invalid_jwt') ||
      msg.includes('token_not_found')
    ) {
      // 리프레시 토큰 에러는 AuthProvider에서 이미 처리하므로 콘솔 노이즈 방지
      event.preventDefault();
      return;
    }
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
